import { useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../constants/urls';
import { notifyAuthChanged, pushClubValidation } from '../utils/dataLayer';

export default function usePromoveLogin() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loginPromove = async (cpf, source, campaign, incentiveId) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(`${BASE_URL}/auth/login/promove`, {
        cpf,
        source,
        campaign,
        incentiveId
      },
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
        },
      }
    );

      const { access_token } = response.data;
      localStorage.setItem('token', access_token);
      notifyAuthChanged();
      pushClubValidation('promoveIsValid');

      setLoading(false);
      return { token: access_token, error: null };
    } catch (err) {
      const message = err?.response?.data?.message || 'Erro no login, verifique seu CPF!';
      setLoading(false);
      setError(message);
      return { token: null, error: message };
    }
  };

  return { loginPromove, loading, error };
}
